import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../components/Col';
import { Container } from '../../../components/Container';
import { CustomButton } from '../../../components/CustomButton';
import FiltrosListagemContratoAssessor from '../../../components/FiltrosListagemContratoAssessor/FiltrosListagemContratoAssessor';
import FiltrosListagemContratoEntePrivado from '../../../components/FiltrosListagemContratoEntePrivado/FiltrosListagemContratoEntePrivado';
import FiltrosListagemContratoEntePublico from '../../../components/FiltrosListagemContratoEntePublico/FiltrosListagemContratoEntePublico';
import NewAutoCompleteField from '../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../components/Row';
import { SearchFiltersContainer } from '../../../components/SearchFiltersContainer';
import { SearchTextField } from '../../../components/SearchTextField';
import { UnauthorizedScreen } from '../../../components/UnauthorizedScreen';
import {
  FLUXO_TIPO_CENTRALIZADO,
  FLUXO_TIPO_DESCENTRALIZADO,
  CONTRATO_TIPO_ASSESSOR,
  CONTRATO_TIPO_ENTE_PRIVADO,
  CONTRATO_TIPO_ENTE_PUBLICO,
  FLUXO_TIPO_TODOS,
} from '../../../library/ContratoTipos';
import {
  cadastroDocumentosContratoRoute,
  contratosRoute,
  modelosDocumentosContratoRoute,
  templatesContratoRoute,
} from '../../../library/Routes';
import {
  clearContratosPageList,
  loadAllContratoTipos,
  loadAllFluxoTipos,
  loadContratosPaginado,
} from '../../../store/modules/ContratosActions';
import { loadCooperativas } from '../../../store/modules/LogradouroActions';
import { closeModal, openModal } from '../../../store/modules/ModalActions';
import { isAuthorizedRequest } from '../../../utils/httpResponseHandlers';
import {
  getAllContratoStatusByType,
  getFluxoTipoByFluxoTipoNumber,
  getContratoTipoByContratoTipoNumber,
} from '../../../utils/ContratoUtils';
import { getElementID, getMergedClassNames } from '../../../utils/HTMLUtils';
import { allIsTrue } from '../../../utils/ValidationUtils';
import styles from './Contratos.scss';
import { ContratoItem } from '../components/ContratoItem/ContratoItem';
import { ModalCadastroContrato } from '../components/ModalCadastroContrato';
import { clearContratoAssessorEditing } from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import { clearContratoAdendos, clearContratoStatusGlobal } from 'store/modules/AllContratos/AllContratosActions';
import { resetFiltersDocumento } from 'store/modules/AllContratos/AllContratosActions';
import { ArrowDownwardOutlined } from '@material-ui/icons';
import Loader from 'components/Loader/Loader';

const rootClassName = styles.rootClassName;
const rootElementId = 'contratos';

export const CONTRATOS_FILTER_PREFIX_TIPO = 'type';
export const CONTRATOS_FILTER_TIPO_FLUXO = 'tipoFluxo';
export const CONTRATOS_FILTER_TIPO_CONTRATO = 'tipoContrato';
export const CONTRATOS_FILTER_COOD_COOP = 'codCoop';
export const CONTRATOS_FILTER_CPF_ASSESSOR = 'cpfAssessor';
export const CONTRATOS_FILTER_ID_EMPRESA = 'idEmpresa';
export const CONTRATOS_FILTER_CNPJ_EMPRESA = 'cnpjEmpresa';
export const CONTRATOS_FILTER_STATUS = 'flgStatus';
export const CONTRATOS_FILTER_ID_ESCOLA = 'idEscola';
export const CONTRATOS_FILTER_ID_ESTADO = 'idEstado';
export const CONTRATOS_FILTER_NOM_CIDADE = 'nomCidade';

const FILTERS_HIERARCHY = {
  [CONTRATOS_FILTER_PREFIX_TIPO + '0']: {
    all: [
      CONTRATOS_FILTER_CPF_ASSESSOR,
      CONTRATOS_FILTER_CNPJ_EMPRESA,
      CONTRATOS_FILTER_ID_ESTADO,
      CONTRATOS_FILTER_NOM_CIDADE,
      CONTRATOS_FILTER_ID_ESCOLA,
    ],
  },
  [CONTRATOS_FILTER_PREFIX_TIPO + CONTRATO_TIPO_ASSESSOR]: {
    all: [CONTRATOS_FILTER_CPF_ASSESSOR, CONTRATOS_FILTER_CNPJ_EMPRESA],
    [CONTRATOS_FILTER_COOD_COOP]: [
      CONTRATOS_FILTER_CPF_ASSESSOR,
      CONTRATOS_FILTER_CNPJ_EMPRESA,
    ],
    [CONTRATOS_FILTER_CPF_ASSESSOR]: [CONTRATOS_FILTER_CNPJ_EMPRESA],
  },
  [CONTRATOS_FILTER_PREFIX_TIPO + CONTRATO_TIPO_ENTE_PUBLICO]: {
    all: [CONTRATOS_FILTER_ID_ESTADO, CONTRATOS_FILTER_NOM_CIDADE],
    [CONTRATOS_FILTER_COOD_COOP]: [
      CONTRATOS_FILTER_ID_ESTADO,
      CONTRATOS_FILTER_NOM_CIDADE,
    ],
    [CONTRATOS_FILTER_ID_ESTADO]: [CONTRATOS_FILTER_NOM_CIDADE],
  },
  [CONTRATOS_FILTER_PREFIX_TIPO + CONTRATO_TIPO_ENTE_PRIVADO]: {
    all: [
      CONTRATOS_FILTER_ID_ESTADO,
      CONTRATOS_FILTER_NOM_CIDADE,
      CONTRATOS_FILTER_ID_ESCOLA,
    ],
    [CONTRATOS_FILTER_COOD_COOP]: [
      CONTRATOS_FILTER_ID_ESTADO,
      CONTRATOS_FILTER_NOM_CIDADE,
      CONTRATOS_FILTER_ID_ESCOLA,
    ],
    [CONTRATOS_FILTER_ID_ESTADO]: [
      CONTRATOS_FILTER_NOM_CIDADE,
      CONTRATOS_FILTER_ID_ESCOLA,
    ],
    [CONTRATOS_FILTER_NOM_CIDADE]: [CONTRATOS_FILTER_ID_ESCOLA],
  },
};

const INITIAL_STATE = {
  authorizedRequest: true,
  searching: true,
  searchingText: '',

  allStatus: [],

  filters: {
    [CONTRATOS_FILTER_TIPO_FLUXO]: 0,
    [CONTRATOS_FILTER_TIPO_CONTRATO]: 0,
    [CONTRATOS_FILTER_COOD_COOP]: '',
    [CONTRATOS_FILTER_CPF_ASSESSOR]: '',
    [CONTRATOS_FILTER_ID_EMPRESA]: '',
    [CONTRATOS_FILTER_CNPJ_EMPRESA]: '',
    [CONTRATOS_FILTER_STATUS]: '',
    [CONTRATOS_FILTER_ID_ESCOLA]: '',
    [CONTRATOS_FILTER_ID_ESTADO]: '',
    [CONTRATOS_FILTER_NOM_CIDADE]: '',
  },
};

export const contratosInitialState = INITIAL_STATE;

class Contratos extends Component {
  isFirstLoad = true;

  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,

      allCoop: {
        codigo: '',
        nome: this.props.languageValues.todosCoop,
      },

      allAssessores: {
        cpf: '',
        nome: this.props.languageValues.todosAssessores,
      },
      allStatus: getAllContratoStatusByType(
        INITIAL_STATE.filters.CONTRATOS_FILTER_TIPO_CONTRATO,
        props.auth,
        props.languageValues,
        true,
        INITIAL_STATE.filters.flgStatus
      ),
    };
  }

  getResetedFirstStatus = () => {
    return this.state.allStatus.length > 0
      ? this.state.allStatus[0].id
      : INITIAL_STATE.filters[CONTRATOS_FILTER_STATUS];
  };

  hasCoopSelected = () => {
    return !this.state.filters[CONTRATOS_FILTER_COOD_COOP] ||
      this.state.filters[CONTRATOS_FILTER_COOD_COOP] ===
      this.state.allCoop.codigo
      ? false
      : true;
  };

  onLoadedFluxoTipos = () => { };

  onLoadedContratoTipos = () => {
    const types = this.getTiposContratos();
    if (types.length > 0) {
      this.tipoContratoChanged(types[0].id);
    } else {
      this.toSearch();
    }
  };

  UNSAFE_componentWillMount() {
    this.props.loadCooperativas();
    this.props.loadAllContratoTipos(this.onLoadedContratoTipos);
    this.props.loadAllFluxoTipos(this.onLoadedFluxoTipos);
  }

  changeSearchingStatus(isSearching, moreProps = {}) {
    if (isSearching !== this.state.searching) {
      this.setState({
        ...this.state,
        searching: isSearching,
        ...moreProps,
      });
    }
  }

  toSearch = (text, page, size) => {
    const busca = text ? String(text).trim() : '';
    page =
      page || this.props.contratos.pageList.page < 1
        ? 1
        : this.props.contratos.pageList.page + 1;
    size = size || this.props.contratos.pageSize;
    this.changeSearchingStatus(true, {
      searchingText: String(text).trim(),
    });
    if (
      Object.values(this.state.filters).join(',') !==
      Object.values(this.props.contratos.pageList.filters).join(',')
    ) {
      page = 1;
      this.props.clearContratosPageList();
    }
    this.props.loadContratosPaginado(
      busca,
      this.state.filters,
      page,
      size,
      () => {
        this.changeSearchingStatus(false);
        this.isFirstLoad = false;
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeSearchingStatus(false);
          this.isFirstLoad = false;
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorSearchingContratos,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeSearchingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  };

  componentWillUnmount() {
    this.props.clearContratosPageList();
    this.isFirstLoad = true;
  }

  showLoadMore = () => {
    return !this.state.searching &&
      this.props.contratos.pageList.totalElements > this.props.contratos.pageList.elements.length;
  };

  getPreloader = () => {
    return (
      <Row>
        <Col
          cols={[12, 12, 12, 12, 12]}
          className='load-more-container'
        >
          <div className='preloader'>
            <Loader dotWidth='12px' dotHeight='12px' dotMargin='0,3' />
          </div>
        </Col>
      </Row>
    );
  };

  toLoadMore = () => {
    this.toSearch(this.props.contratos.pageList.busca);
  };

  getLegendResults = () => {
    let legend = '';
    const text = this.state.searchingText;
    if (this.props.contratos.pageList.totalElements === 1) {
      legend =
        text.length === 0
          ? this.props.languageValues.legendContratosResultSingularEmpty
          : this.props.languageValues.legendContratosResultSingular;
    } else {
      legend =
        text.length === 0
          ? this.props.languageValues.legendContratosResultPluralEmpty
          : this.props.languageValues.legendContratosResultPlural;
    }
    return (
      legend
        /* eslint-disable-next-line */
        .split('${1}')
        .join(this.props.contratos.pageList.elements.length)
        /* eslint-disable-next-line */
        .split('${2}')
        .join(this.props.contratos.pageList.totalElements)
        /* eslint-disable-next-line */
        .split('${3}')
        .join(this.state.searchingText)
    );
  };

  getClearedFiltersByFieldNames = (fieldNames) => {
    let obj = {};
    (fieldNames || []).map((fieldName) => {
      obj[fieldName] = INITIAL_STATE.filters[fieldName];
      return fieldName;
    });
    return obj;
  };

  getClearedFiltersByHierarchy = (newValues) => {
    let values = { ...this.state.filters, ...newValues };
    let filterHierarchyTypeEmpty =
      FILTERS_HIERARCHY[CONTRATOS_FILTER_PREFIX_TIPO + 0];
    let filterHierarchyType =
      FILTERS_HIERARCHY[
      CONTRATOS_FILTER_PREFIX_TIPO + values[CONTRATOS_FILTER_TIPO_CONTRATO]
      ];
    if (
      values[CONTRATOS_FILTER_TIPO_CONTRATO] !==
      this.state.filters[CONTRATOS_FILTER_TIPO_CONTRATO]
    ) {
      return {
        ...values,
        ...this.getClearedFiltersByFieldNames(filterHierarchyTypeEmpty.all),
      };
    } else if (
      values[CONTRATOS_FILTER_STATUS] !==
      this.state.filters[CONTRATOS_FILTER_STATUS]
    ) {
      return {
        ...values,
        ...this.getClearedFiltersByFieldNames(
          filterHierarchyType[CONTRATOS_FILTER_STATUS]
        ),
      };
    } else {
      if (
        values[CONTRATOS_FILTER_COOD_COOP] !==
        this.state.filters[CONTRATOS_FILTER_COOD_COOP]
      ) {
        values = {
          ...values,
          ...this.getClearedFiltersByFieldNames(
            filterHierarchyType[CONTRATOS_FILTER_COOD_COOP]
          ),
        };
      }
      switch (values[CONTRATOS_FILTER_TIPO_CONTRATO]) {
        case CONTRATO_TIPO_ASSESSOR:
          if (
            values[CONTRATOS_FILTER_CPF_ASSESSOR] !==
            this.state.filters[CONTRATOS_FILTER_CPF_ASSESSOR]
          ) {
            values = {
              ...values,
              ...this.getClearedFiltersByFieldNames(
                filterHierarchyType[CONTRATOS_FILTER_CPF_ASSESSOR]
              ),
            };
          }
          return values;

        case CONTRATO_TIPO_ENTE_PUBLICO:
          if (
            values[CONTRATOS_FILTER_ID_ESTADO] !==
            this.state.filters[CONTRATOS_FILTER_ID_ESTADO]
          ) {
            values = {
              ...values,
              ...this.getClearedFiltersByFieldNames(
                filterHierarchyType[CONTRATOS_FILTER_ID_ESTADO]
              ),
            };
          }
          return values;

        case CONTRATO_TIPO_ENTE_PRIVADO:
          if (
            values[CONTRATOS_FILTER_ID_ESTADO] !==
            this.state.filters[CONTRATOS_FILTER_ID_ESTADO]
          ) {
            values = {
              ...values,
              ...this.getClearedFiltersByFieldNames(
                filterHierarchyType[CONTRATOS_FILTER_ID_ESTADO]
              ),
            };
          }

          if (
            values[CONTRATOS_FILTER_NOM_CIDADE] !==
            this.state.filters[CONTRATOS_FILTER_NOM_CIDADE]
          ) {
            values = {
              ...values,
              ...this.getClearedFiltersByFieldNames(
                filterHierarchyType[CONTRATOS_FILTER_NOM_CIDADE]
              ),
            };
          }

          return values;

        default:
          return {
            ...values,
            ...this.getClearedFiltersByFieldNames(filterHierarchyTypeEmpty.all),
          };
      }
    }
  };

  changeValuesToSearch = (values, otherState) => {
    this.props.clearContratosPageList();
    const newValues = this.getClearedFiltersByHierarchy(values);
    this.setState(
      {
        ...(otherState || {}),
        filters: newValues,
      },
      () => {
        this.toSearch(this.props.contratos.pageList.busca);
      }
    );
  };

  getAllStatus = () => { };

  tipoFluxoChanged = (newTipo) => {
    const newAllStatus = getAllContratoStatusByType(
      newTipo,
      this.props.auth,
      this.props.languageValues,
      true,
      INITIAL_STATE.filters.flgStatus
    );
    let newValues = {
      [CONTRATOS_FILTER_TIPO_FLUXO]: newTipo,
    };
    if (
      newAllStatus.filter(
        (status) => status.id === this.state.filters[CONTRATOS_FILTER_STATUS]
      ).length === 0
    ) {
      newValues[CONTRATOS_FILTER_STATUS] = newAllStatus[0].id;
    }
    this.changeValuesToSearch(newValues, {
      allStatus: newAllStatus,
    });
  };

  tipoContratoChanged = (newTipo) => {
    const newAllStatus = getAllContratoStatusByType(
      newTipo,
      this.props.auth,
      this.props.languageValues,
      true,
      INITIAL_STATE.filters.flgStatus
    );
    let newValues = {
      [CONTRATOS_FILTER_TIPO_CONTRATO]: newTipo,
    };
    if (
      newAllStatus.filter(
        (status) => status.id === this.state.filters[CONTRATOS_FILTER_STATUS]
      ).length === 0
    ) {
      newValues[CONTRATOS_FILTER_STATUS] = newAllStatus[0].id;
    }
    this.changeValuesToSearch(newValues, {
      allStatus: newAllStatus,
    });
  };

  changeSelectedCoop = (newCoop) => {
    this.changeValuesToSearch({
      selectedCoop:
        typeof newCoop === 'string' && newCoop.length > 0 ? newCoop : '',
    });
  };

  changeSelectedContrato = (newContrato) => {
    this.props.clearContratosPageList();
    this.setState(
      {
        ...this.state,
        selectedContrato: newContrato,
      },
      () => {
        this.toSearch(this.props.contratos.pageList.busca);
      }
    );
  };

  toNewSearch = (newText) => {
    this.props.clearContratosPageList();
    this.toSearch(newText, 1);
  };

  getAllCoops = () => {
    if (
      this.props.logradouro.cooperativas &&
      this.props.logradouro.cooperativas.length > 0
    ) {
      return [
        {
          ...this.state.allCoop,
        },
        ...this.props.logradouro.cooperativas,
      ];
    }
    return [];
  };

  getButtonsClassName = () => {
    if (
      this.props.auth.userPermissions.contratos.assessor.register &&
      this.props.auth.userPermissions.contratos.assessor.templates.list
    ) {
      return rootClassName + '-two-buttons';
    } else {
      return rootClassName + '-one-button';
    }
  };

  getButtonsCols = () => {
    if (this.props.auth.userPermissions.contratos.assessor.register &&
      this.props.auth.userPermissions.contratos.assessor.templates.list) {
      return [12, 12, 5, 2, 2];
    } else {
      return [12, 4, 4, 2, 2];
    }
  };

  getSearchTextFieldCols = () => {
    const { register, templates } = this.props.auth.userPermissions.contratos.assessor;

    if (register && templates) {
      return [12, 12, 12, 4, 4];
    } else if (register || templates) {
      return [12, 12, 8, 4, 4];
    } else {
      return [12, 12, 12, 6, 6];
    }
  };

  openCadastro() {
    this.props.clearContratoAssessorEditing();
    this.props.clearContratoStatusGlobal()
    this.props.clearContratoAdendos();
    this.props.openModal(
      ModalCadastroContrato,
      this.props.history.push(contratosRoute.path)
    );
  }

  getTiposFluxos = () => {
    const allTypes = [...(this.props.contratos.tiposFluxos || [])];
    const viewAllTypes = allIsTrue([
      this.props.auth.userPermissions.contratos.assessor.view,
      this.props.auth.userPermissions.contratos.entePublico.view,
      this.props.auth.userPermissions.contratos.entePrivado.view,
    ]);
    if (viewAllTypes) {
      return allTypes;
    }
    return allTypes.filter((type) => {
      return (
        (type.id === FLUXO_TIPO_TODOS ||
          type.id === FLUXO_TIPO_CENTRALIZADO ||
          type.id === FLUXO_TIPO_DESCENTRALIZADO) &&
        (this.props.auth.userPermissions.contratos.assessor.view ||
          this.props.auth.userPermissions.contratos.entePublico.view ||
          this.props.auth.userPermissions.contratos.entePrivado.view)
      );
    });
  };

  getTiposContratos = () => {
    const allTypes = [...(this.props.contratos.tiposContratos || [])];
    const viewAllTypes = allIsTrue([
      this.props.auth.userPermissions.contratos.assessor.view,
      this.props.auth.userPermissions.contratos.entePublico.view,
      this.props.auth.userPermissions.contratos.entePrivado.view,
    ]);
    if (viewAllTypes) {
      return allTypes;
    }
    return allTypes.filter((type) =>
      (type.id === CONTRATO_TIPO_ASSESSOR && this.props.auth.userPermissions.contratos.assessor.view) ||
      (type.id === CONTRATO_TIPO_ENTE_PUBLICO && this.props.auth.userPermissions.contratos.entePublico.view) ||
      (type.id === CONTRATO_TIPO_ENTE_PRIVADO && this.props.auth.userPermissions.contratos.entePrivado.view)
    );
  };

  render() {
    return this.state.authorizedRequest &&
      this.props.auth.userPermissions.contratos.list ? (
      <Container className={rootClassName + '-container container-fluid'}>
        <div className='container-fluid'>
          <Row className={rootClassName + '-header'}>
            {this.props.auth.userPermissions.contratos.assessor.register ? (
              <Col cols={this.getButtonsCols()}>
                <CustomButton
                  theme='pufvYellow'
                  className={getMergedClassNames([
                    rootClassName + '-create-button',
                    this.getButtonsClassName(),
                  ])}
                  label={this.props.languageValues.newContratoButton}
                  onClick={() => {
                    this.openCadastro();
                  }}
                />
              </Col>
            ) : null}
            {this.props.auth.userPermissions.contratos.assessor.templates
              .list ? (
              <Col cols={this.getButtonsCols()}>
                <CustomButton
                  theme='pufvYellow'
                  className={getMergedClassNames([
                    rootClassName + '-edit-templates-button',
                    this.getButtonsClassName(),
                  ])}
                  label={this.props.languageValues.editTemplatesButton}
                  onClick={() => {
                    this.props.history.push(templatesContratoRoute.path);
                  }}
                />
              </Col>
            ) : null}
            {this.props.auth.userPermissions.contratos.assessor.register ? (
              <Col cols={this.getButtonsCols()}>
                <CustomButton
                  theme='pufvYellow'
                  className={getMergedClassNames([
                    rootClassName + '-modelos-de-documentos-button',
                    this.getButtonsClassName(),
                  ])}
                  label={this.props.languageValues.modelosDeDocumentos}
                  onClick={() => {
                    this.props.resetFiltersDocumento()
                    this.props.history.push(modelosDocumentosContratoRoute.path);
                  }}
                />
              </Col>
            ) : null}
            {this.props.auth.userPermissions.contratos.assessor.templates
              .list ? (
              <Col cols={this.getButtonsCols()}>
                <CustomButton
                  theme='pufvYellow'
                  className={getMergedClassNames([
                    rootClassName + '-upload-documentos-button',
                    this.getButtonsClassName(),
                  ])}
                  label={this.props.languageValues.cadastrarDocumentos}
                  onClick={() => {
                    window.open(cadastroDocumentosContratoRoute.path, '_blank');
                  }}
                />
              </Col>
            ) : null}
            {this.props.auth.userPermissions.contratos.assessor.templates.list ? (
              <>
                <Col cols={[12, 12, 12, 4, 4]}>
                  <SearchTextField
                    id={getElementID(rootElementId, 'search')}
                    disabled={this.state.searching}
                    onSearchClick={this.toNewSearch}
                    placeholder={
                      this.props.languageValues.contratosSearchPlaceholder
                    }
                  />
                </Col>
              </>
            ) : (
              <>
                <Col cols={[12, 12, 12, 8, 8]}>
                  <SearchTextField
                    id={getElementID(rootElementId, 'search')}
                    disabled={this.state.searching}
                    onSearchClick={this.toNewSearch}
                    placeholder={
                      this.props.languageValues.contratosSearchPlaceholder
                    }
                  />
                </Col>
              </>
            )}
          </Row>
          <SearchFiltersContainer className='margin-bottom-30'>
            <Row>
              <Col cols={[12, 12, 6, 6, 6]}>
                <NewAutoCompleteField
                  label={this.props.languageValues.filterTipoFluxo}
                  className={rootClassName + '-status-filter'}
                  inputClassName={rootClassName + '-status-input-filter'}
                  placeholder={
                    this.props.contratos.loadingTiposFluxos
                      ? this.props.languageValues.loadingTiposFluxos
                      : this.props.languageValues.nenhumTipoFluxoSelect
                  }
                  options={this.getTiposFluxos().map((fluxo) => {
                    return {
                      label:
                        fluxo.id === 0
                          ? this.props.languageValues.allTiposFluxo
                          : this.props.languageValues.fluxoTipos[
                            getFluxoTipoByFluxoTipoNumber(fluxo.id)
                          ].name,
                      value: fluxo.id,
                    };
                  })}
                  value={this.state.filters[CONTRATOS_FILTER_TIPO_FLUXO]}
                  onChange={(value) => {
                    if (
                      value &&
                      value.value !==
                      this.state.filters[CONTRATOS_FILTER_TIPO_FLUXO]
                    ) {
                      this.tipoFluxoChanged(value.value);
                    } else {
                      this.tipoFluxoChanged(
                        INITIAL_STATE.filters[CONTRATOS_FILTER_TIPO_FLUXO]
                      );
                    }
                  }}
                  disabled={this.state.searching}
                />
              </Col>
            </Row>
          </SearchFiltersContainer>
          <SearchFiltersContainer className='margin-bottom-30'>
            <Row>
              <Col cols={[12, 12, 6, 6, 6]}>
                <NewAutoCompleteField
                  label={this.props.languageValues.filterTipoContrato}
                  className={rootClassName + '-status-filter'}
                  inputClassName={rootClassName + '-status-input-filter'}
                  placeholder={
                    this.props.contratos.loadingTiposContratos
                      ? this.props.languageValues.loadingTiposContratos
                      : this.props.languageValues.nenhumTipoContratoSelect
                  }
                  options={this.getTiposContratos().map((contrato) => {
                    return {
                      label:
                        contrato.id === 0
                          ? this.props.languageValues.allTiposContrato
                          : this.props.languageValues.contratoTipos[
                            getContratoTipoByContratoTipoNumber(contrato.id)
                          ].name,
                      value: contrato.id,
                    };
                  })}
                  value={this.state.filters[CONTRATOS_FILTER_TIPO_CONTRATO]}
                  onChange={(value) => {
                    if (
                      value &&
                      value.value !==
                      this.state.filters[CONTRATOS_FILTER_TIPO_CONTRATO]
                    ) {
                      this.tipoContratoChanged(value.value);
                    } else {
                      this.tipoContratoChanged(
                        INITIAL_STATE.filters[CONTRATOS_FILTER_TIPO_CONTRATO]
                      );
                    }
                  }}
                  disabled={this.state.searching}
                />
              </Col>
              <Col cols={[12, 12, 6, 6, 6]}>
                <NewAutoCompleteField
                  label={this.props.languageValues.cooperativasFilterLabel}
                  className={rootClassName + '-coop-filter'}
                  inputClassName={rootClassName + '-coop-input-filter'}
                  disabled={
                    this.state.searching ||
                    this.props.logradouro.loadingCooperativas
                  }
                  placeholder={
                    this.props.logradouro.loadingCooperativas
                      ? this.props.languageValues.loadingCooperativas
                      : ''
                  }
                  options={this.getAllCoops().map((coop) => {
                    return {
                      label: coop.nome,
                      value: coop.codigo,
                    };
                  })}
                  value={this.state.filters[CONTRATOS_FILTER_COOD_COOP]}
                  onChange={(value) => {
                    if (
                      value &&
                      value.value !==
                      this.state.filters[CONTRATOS_FILTER_COOD_COOP]
                    ) {
                      this.changeValuesToSearch({
                        [CONTRATOS_FILTER_COOD_COOP]: value.value,
                      });
                    } else {
                      this.changeValuesToSearch({
                        [CONTRATOS_FILTER_COOD_COOP]:
                          INITIAL_STATE.filters[CONTRATOS_FILTER_COOD_COOP],
                      });
                    }
                  }}
                  loading={this.props.logradouro.loadingCooperativas}
                  loadingMessage={this.props.languageValues.loadingCooperativas}
                />
              </Col>
              <Col cols={[12, 12, 6, 6, 6]}>
                <NewAutoCompleteField
                  label={this.props.languageValues.contratoStatus}
                  className={rootClassName + '-status-filter'}
                  inputClassName={rootClassName + '-status-input-filter'}
                  placeholder={this.props.languageValues.allStatus}
                  options={this.state.allStatus.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  })}
                  value={this.state.filters[CONTRATOS_FILTER_STATUS]}
                  onChange={(value) => {
                    if (
                      value &&
                      value.value !==
                      this.state.filters[CONTRATOS_FILTER_STATUS]
                    ) {
                      this.changeValuesToSearch({
                        [CONTRATOS_FILTER_STATUS]: value.value,
                      });
                    } else {
                      this.changeValuesToSearch({
                        [CONTRATOS_FILTER_STATUS]: this.getResetedFirstStatus(),
                      });
                    }
                  }}
                  disabled={this.state.searching}
                />
              </Col>
              {this.state.filters[CONTRATOS_FILTER_TIPO_CONTRATO] ===
                CONTRATO_TIPO_ASSESSOR ? (
                <FiltrosListagemContratoAssessor
                  loading={this.state.searching}
                  filters={this.state.filters}
                  changeValues={this.changeValuesToSearch}
                />
              ) : null}
              {this.state.filters[CONTRATOS_FILTER_TIPO_CONTRATO] ===
                CONTRATO_TIPO_ENTE_PUBLICO ? (
                <FiltrosListagemContratoEntePublico
                  loading={this.state.searching}
                  filters={this.state.filters}
                  changeValues={this.changeValuesToSearch}
                />
              ) : null}
              {this.state.filters[CONTRATOS_FILTER_TIPO_CONTRATO] ===
                CONTRATO_TIPO_ENTE_PRIVADO ? (
                <FiltrosListagemContratoEntePrivado
                  loading={this.state.searching}
                  filters={this.state.filters}
                  changeValues={this.changeValuesToSearch}
                />
              ) : null}
            </Row>
          </SearchFiltersContainer>
          {!this.state.searching ? (
            <Row>
              <Col cols={[12, 12, 12, 12, 12]}>{this.getLegendResults()}</Col>
            </Row>
          ) : (
            ''
          )}
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + '-list-items'}
            >
              {this.props.contratos.pageList.elements.map((contrato, index) => {
                return <ContratoItem contrato={contrato} key={index} />;
              })}
            </Col>
          </Row>
          {this.showLoadMore() ? (
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-load-more-container'}
              >
                <CustomButton
                  theme='pufvYellow'
                  label={this.props.languageValues.loadMoreContratoButton}
                  onClick={() => this.toLoadMore()}
                  rightIcon={<ArrowDownwardOutlined />}
                />
              </Col>
            </Row>
          ) : (
            ''
          )}
          {this.state.searching ? this.getPreloader() : ''}
        </div>
      </Container >
    ) : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  logradouro: state.logradouro,
  assessores: state.assessores,
  contratos: state.contratos,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
      loadCooperativas,
      clearContratosPageList,
      clearContratoStatusGlobal,
      clearContratoAdendos,
      clearContratoAssessorEditing,
      loadContratosPaginado,
      loadAllContratoTipos,
      loadAllFluxoTipos,
      resetFiltersDocumento
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Contratos));

